'use strict';

angular.module('user')
    .component('userMain', {
        templateUrl: 'js/modules/user/components/main/template.html',
        controller: 'UserMainController',
    });
